<!--
 * @Description: 
 * @Author: HG
 * @Date: 2019-08-08 17:38:24
 * @LastEditors: HG
 * @LastEditTime: 2019-09-27 15:28:59
 -->
<template>
  <div class="container">
    <head-nav-bar :title="title" :fixed="true" />
    <div class="doctor-list mt-header-nav">
      <form action="/">
        <van-search
          v-model="keyword"
          placeholder="请输入搜索关键词"
          @search="onSearch"
          @clear="onClear"
        >
        </van-search>
      </form>
      <DataList api="Doctor_List" :params="params">
        <template v-slot:item="item">
          <div class="doctor-item" @click="selectedDoctor(item.obj)">
            <doctor-card :data="item.obj" />
          </div>
        </template>
      </DataList>
    </div>
  </div>
</template>

<script>
import { Search } from "vant";
import DataList from "@/components/DataList";
import DoctorCard from "@/components/DoctorCard";
import { formatDate, countDate } from "@/utils/common";
import { mapActions } from "vuex";

export default {
  name: "DoctorList",
  components: {
    DataList,
    DoctorCard,
    [Search.name]: Search,
  },
  data() {
    return {
      title: "选择医生",
      keyword: "",
      type: "",
      params: {},
    };
  },
  created() {
    this.type = this.$route.query.type;
    if (!this.type) {
      this.params.StartWorkDate = countDate(formatDate(), 1);
      this.params.EndWorkDate = countDate(this.params.StartWorkDate, 13);
    } else {
      this.params.StartWorkDate = formatDate();
      this.params.EndWorkDate = this.params.StartWorkDate;
    }
  },
  methods: {
    ...mapActions(["setDoctor"]),
    onSearch(keyword) {
      const params = {
        Name: keyword,
      };

      if (!this.type) {
        params.StartWorkDate = countDate(formatDate(), 1);
        params.EndWorkDate = countDate(params.StartWorkDate, 13);
      } else {
        params.StartWorkDate = formatDate();
        params.EndWorkDate = formatDate();
      }
      this.params = params;
    },
    onClear() {
      this.params = {};
    },
    selectedDoctor(info) {
      this.setDoctor(info);
      let query = {
        Id: info.id,
        QueueId: info.queueId,
      };
      if (this.type === "today") {
        query.date = formatDate();
      }
      this.$router.push({ name: "servePreOrderDoctorInfo", query });
    },
  },
};
</script>

<style lang="less"></style>
